import { render, staticRenderFns } from "./AdvisoryFunds.vue?vue&type=template&id=36bb29ac&scoped=true"
import script from "./AdvisoryFunds.vue?vue&type=script&lang=ts"
export * from "./AdvisoryFunds.vue?vue&type=script&lang=ts"
import style0 from "./AdvisoryFunds.vue?vue&type=style&index=0&id=36bb29ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb29ac",
  null
  
)

export default component.exports